import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import ModuleDetail from "../common/ModuleDetail";
import DataApi from "../../api/dataApi";
import { Card, Col, Row } from "react-bootstrap";
import { convertToUserTimezone } from "../../utils/convertTimeZone";
import { useTimeZone } from "../../contexts/TimeZoneContext";

import { COUNTRY_CODES } from "../../constants/COUNTRY_CODES";
import City_State from "../../constants/CityState.json";
import { Country, State, City } from "country-state-city";


const PublisherDetail = ({ permissions }) => {

    const { id } = useParams();

    const [book, setBook] = useState(null);

    const [totalBooks, setTotalBooks] = useState(0);

    const other = permissions?.allowEdit
        ? {
            other: [
            { key: "createdbyid", label: "Created By", type: "text" },

            {
                key: "createddate", label: "Created Date", type: "date", render: (value) => {
                    return convertToUserTimezone(value, timeZone)
                },
            },
            {
                key: "lastmodifieddate", label: "Last Modified Date", type: "date", render: (value) => {
                    return convertToUserTimezone(value, timeZone)
                },
            },
            { key: "lastmodifiedbyid", label: "Last Modified By", type: "text" },
        ], 
        }
        : {};   



    const { timeZone } = useTimeZone();
    const fetchBookData = async (bookId) => {
        try {

            const bookApi = new DataApi("publisher");

            const bookResponse = await bookApi.fetchById(bookId);
            const bookData = bookResponse?.data || {};
            setBook(bookData);




        } catch (error) {
            console.error("Error fetching book or book issues:", error);
        }
    };



    useEffect(() => {
        if (id) {
            fetchBookData(id);
        }
    }, [id]);


    const countryOptions = Country.getAllCountries().map((country) => ({
        value: country.isoCode,
        label: `${country.flag} ${country.name}`,
    }));

    //red star for required fields
    const requiredLabel = (label) => {
        return <span>{label} <span style={{ color: 'red' }}>*</span></span>;
    };


    console.log("countryOptions =>", countryOptions);

    const fields = {
        details: [
            {
                key: "salutation",
                label: "Salutation",
                type: "text"
            },
    
            {
                key: "name",
                label: requiredLabel("Name"),
                type: "text",
                colSize: 6,
            },
            {
                key: "email",
                label: requiredLabel("Email"),
              
                type: "email"
            },
            {
                key: "phone",
                label: requiredLabel("Phone"),
                type: "tel"
            },

            //  {
            //     key: "country",
            //     label: "Country",
            //     type: "select",
            //     options: countryOptions,

            // },
           {
                key: "country",
                label: "Country",
                type: "select",
                isSearchable: true,
                placeholder: "Select Country...",
                options: countryOptions,
                render: (value) => {
                    if (!value) return "-";
                    const country = Country.getCountryByCode(value);
                    return country ? country.name : value;
                }
            },
           {
                key: "state",
                label: "State",
                type: "select",
                isSearchable: true,
                placeholder: "Select State...",
                options: (formData) => {
                    if (!formData?.country) return [];

                    return State.getStatesOfCountry(formData.country).map((s) => ({
                        value: s.isoCode,
                        label: s.name,
                    }));
                },
                render: (value, row) => {
                    if (!value || !row?.country) return "-";
                    const state = State.getStateByCodeAndCountry(value, row.country);
                    return state ? state.name : value;
                }
            },
            {
                key: "city",
                label: "City",
                type: "select",
                isSearchable: true,
                placeholder: "Select City...",
                options: (formData) => {
                    if (!formData?.country || !formData?.state) return [];

                    return City.getCitiesOfState(formData.country, formData.state).map((c) => ({
                        value: c.name,
                        label: c.name,
                    }));
                },
                render: (value) => value || "-"
            },
            {
                key: "is_active",
                label: "Active",
                type: "toggle"
            },
        ],
        ...other,
    };

    return (
        <>
            <Row>
                <Col lg={12} className="mb-3">
                    {book && (
                        <ModuleDetail
                            moduleName="publisher"
                            moduleApi="publisher"
                            moduleLabel="Publisher"
                            icon="fa fa-address-card"
                            fields={fields}
                            permissions={permissions || {}}
                        />
                    )}
                </Col>
            </Row >
        </>
    );
};

export default PublisherDetail;